import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";
import React from "react";

export default function NewParameterButton({
  authSubject,
  onAdd,
  disabled,
  ...props
}) {
  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.NEW_RECORD,
    authSubject
  );

  return (
    <Button
      type="primary"
      disabled={IsAuthorized ? disabled : true}
      shape="circle"
      onClick={() => {
        if (onAdd) onAdd();
      }}
      icon={<FontAwesomeIcon icon={["fas", "plus"]} />}
    />
  );
}
